<template>
    <b-sidebar
            class="bootstrap-sidebar"
            :visible="isVisible"
            :right="right"
            :bg-variant="bgVariant"
            :shadow="shadow"
            :backdrop="backdrop"
            :lazy="lazy"
            :no-header-close="noHeaderClose"
            :text-variant="textVariant"
            body-class="d-md-flex align-items-start align-items-md-center flex-column"
            :no-close-on-route-change="!isMobile && !isTablet"
            no-close-on-esc
            :no-close-on-backdrop="!isMobile && !isTablet"
            @change="handleInput"
    >
        <template v-slot:header-close>
            <i
                    class="far fa-times text-white"
            />
        </template>
        <div class="mobile-white-section w-100 d-flex flex-column">
            <div
                    class="bell-wrapper d-block d-lg-none"
            >
                <slot name="bell" />
            </div>
            <div class="logo-wrapper align-self-center text-center">
                <slot
                        name="logo"
                        class="logo"
                >
                    <b-skeleton-img
                            v-if="logo.loading"
                            width="4.375rem"
                    />
                    <b-img
                            v-else-if="logo && logo.path"
                            class="logo"
                            width="50"
                            :src="logo.path"
                            alt="Main Logo"
                    />
                </slot>
            </div>
            <div class="navigation w-100">
                <b-nav
                        class="margin-top w-100"
                        vertical
                        align="center"
                        fill
                >
                    <slot name="navigation-items">
                        <template
                                v-for="(item, index) in navItems"
                        >
                            <b-nav-item
                                    :key="index"
                                    :active="isActive(item)"
                                    exact
                                    exact-active-class="active"
                                    @click="handleNavItemClick(item)"
                                    :id="`popover-${index}`"
                            >
                                <i
                                        class="far"
                                        :class="item.icon"
                                />
                                <h3 class="label d-block d-lg-none mb-0">
                                    {{ item.label }}
                                </h3>
                                <span
                                        class="nav-item-dot"
                                        v-if="item.showDot"
                                />
                                <b-popover
                                        v-if="item.popover && !isMobile"
                                        :target="`popover-${index}`"
                                        :id="`popover-${item.action}`"
                                        placement="right"
                                        boundary="window"
                                        custom-class="popover-nav-item"
                                        variant="custom"
                                        triggers="hover"
                                >
                                    <h3 class="mb-0 font-weight-normal">
                                        {{ item.popover }}
                                    </h3>
                                </b-popover>
                            </b-nav-item>
                        </template>
                    </slot>
                </b-nav>
            </div>
        </div>
        <div class="navigation-bottom mt-md-auto w-100">
            <b-nav
                    class="w-100"
                    vertical
                    align="center"
                    fill
            >
                <slot name="navigation-bottom-items">
                    <template
                            v-for="(item, index) in navItemsBottom"
                    >
                        <b-nav-item
                                :key="index"
                                :active="isActiveBottom(item)"
                                exact
                                exact-active-class="active"
                                @click="handleNavItemClick(item)"
                                :id="`popover-bottom-${index}`"
                        >
                            <h3 class="label d-block d-lg-none mb-0">
                                {{ item.label }}
                            </h3>
                            <i
                                    class="far ml-auto ml-md-0"
                                    :class="item.icon"
                            />
                            <span
                                    class="nav-item-dot"
                                    v-if="item.showDot"
                            />
                            <b-popover
                                    v-if="item.popover && !isMobile"
                                    :target="`popover-bottom-${index}`"
                                    placement="right"
                                    boundary="window"
                                    custom-class="popover-nav-item"
                                    variant="custom"
                                    triggers="hover"
                            >
                                <h3 class="mb-0 font-weight-normal">
                                    {{ item.popover }}
                                </h3>
                            </b-popover>
                        </b-nav-item>
                    </template>
                </slot>
            </b-nav>
        </div>
        <template v-if="!noSignOut">
            <div class="log-out">
                <b-button
                        @click="handleSignOut"
                        variant="link"
                        block
                        class="d-flex justify-content-start justify-content-md-center positioning-mobile"
                        id="popover-log-out"
                >
                    <h3 class="label d-lg-none font-weight-normal mb-0">
                        Sign Out
                    </h3>
                    <i
                            class="far fa-sign-out ml-auto ml-md-0"
                    />
                </b-button>
                <b-popover
                        v-if="!isMobile"
                        target="popover-log-out"
                        placement="right"
                        custom-class="popover-nav-item popover-logout"
                        variant="custom"
                        :boundary-padding="85"
                        triggers="hover"
                >
                    <h3 class="mb-0 font-weight-normal">
                        Sign Out
                    </h3>
                </b-popover>
            </div>
        </template>
        <slot name="bottom" />
    </b-sidebar>
</template>

<script>
import './CommonSidebar.scss';
import './CommonSidebar.mobile.scss';
import {ANIMATE_HAMBURGER} from "../../../components/AnimateHamburger/AnimateHamburger.vue";
import IsMobileMixin from "../../../mixins/IsMobileMixin";
import isEqual from 'lodash/isEqual';

export const PROJECTS = 'projects';
export const LANDING_PAGES = 'lading-pages';
export const ORGANIZATION = 'organization';
export const CONTACTS = 'contacts';
export const OPPORTUNITIES = 'opportunities';
export const HELP_CENTER = 'help-center';
export const MY_PROFILE = 'my-profile';
export const SIGN_OUT = 'sign-out';
export const DASHBOARD = 'dashboard';
export const TODAY = 'today';
export const LISTINGS_AND_TRANSACTIONS = 'listings-and-transactions';
export const MARKETPLACE = 'marketplace';


export const ACTION_NAMES = {
    PROJECTS,
    LANDING_PAGES,
    ORGANIZATION,
    CONTACTS,
    OPPORTUNITIES,
    HELP_CENTER,
    MY_PROFILE,
    SIGN_OUT,
    DASHBOARD,
    LISTINGS_AND_TRANSACTIONS,
    MARKETPLACE,
    TODAY
};
export const NAV_ITEMS = [
    {
        icon: 'fa-tachometer-fast',
        label: 'Dashboard',
        popover: 'Dashboard',
        action: DASHBOARD,
    },
    {
        icon: 'fa-flag',
        label: 'Today',
        popover: 'Today',
        action: TODAY,
    },
    {
        icon: 'fa-chart-network',
        label: 'Hubs',
        popover: 'My Hubs',
        action: PROJECTS,
    },
    {
        icon: 'fa-sack-dollar',
        label: 'Opportunities',
        popover: 'My Opportunities',
        action: OPPORTUNITIES,
    },
    {
        icon: 'fa-users',
        label: 'Contacts',
        popover: 'Contacts',
        action: CONTACTS,
        showDot: false,
    },
    {
        icon: 'fa-browser',
        label: 'Landing Pages',
        popover: 'Landing Pages',
        action: LANDING_PAGES,
    },
    {
        icon: 'fa-file-invoice-dollar',
        label: 'Listings & Transactions',
        popover: 'Listings & Transactions',
        action: LISTINGS_AND_TRANSACTIONS,
    },
    {
        icon: 'fa-handshake',
        label: 'Service Providers',
        popover: 'Service Providers',
        action: MARKETPLACE,
    },
    {
        icon: 'fa-university',
        label: 'Organization',
        popover: 'Organization',
        action: ORGANIZATION,
    },
];
export const NAV_ITEMS_BOTTOM = [
    {
        icon: 'fa-life-ring',
        label: 'Help Center',
        popover: 'Help Center',
        action: HELP_CENTER,
    },
    {
        icon: 'fa-user-circle',
        label: 'My Profile',
        popover: 'My Profile',
        action: MY_PROFILE,
        showDot: false,
    },
];
export default {
    name: "CommonSidebar",
    mixins: [IsMobileMixin],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        noHeaderClose: {
            type: Boolean,
            default: false
        },
        bgVariant: {
            type: String,
            default: 'white'
        },
        textVariant: {
            type: String,
            default: 'white'
        },
        shadow: {
            type: [String, Boolean],
            default: 'custom'
        },
        backdrop: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        },
        navItems: {
            type: Array,
            default: () => {
                return NAV_ITEMS;
            }
        },
        navItemsBottom: {
            type: Array,
            default: () => {
                return NAV_ITEMS_BOTTOM;
            }
        },
        navItemActive: {
            type: [Object, Array],
            default: () => {
                return {};
            }
        },
        navBottomItemActive: {
            type: [Object, Array],
            default: () => {
                return {};
            }
        },
        logo: {
            type: Object,
            default: () => {
                return {
                    path: require('../../../static/logo.png')
                };
            }
        },
        showBell: {
            type: Boolean,
            default: true
        },
        noSignOut: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isVisible: this.visible
        };
    },
    computed: {},
    methods: {
        handleInput(value) {
            this.isVisible = value;
            this.$uiBus.$emit(ANIMATE_HAMBURGER, this.isVisible);
            this.moveContent();
        },
        handleSignOut() {
            this.$emit('sign-out', true);
            this.$emit('click', {action: SIGN_OUT});
        },
        handleNavItemClick(value) {
            this.$emit('click', value);
        },
        onAnimateHamburger(value) {
            this.isVisible = value;
        },
        isActive(item) {
            if (Array.isArray(this.navItemActive)) {
                return this.navItemActive.includes(item);
            }
            return isEqual(this.navItemActive, item);
        },
        isActiveBottom(item) {
            if (Array.isArray(this.navBottomItemActive)) {
                return this.navBottomItemActive.includes(item);
            }
            return isEqual(this.navBottomItemActive, item);
        },
        moveContent() {
            if (!this.isMobile) {
                return;
            }
            this.$root.$el.style.marginLeft = this.isVisible ? '-7.9125rem' : null;
        }
    },

    watch: {
        visible(value) {
            this.isVisible = value;
        },
        isMobile() {
            this.$root.$el.style.marginLeft = null;
        }
    },
    mounted() {
        this.$uiBus.$on(ANIMATE_HAMBURGER, this.onAnimateHamburger);
    },
    beforeDestroy() {
        this.$uiBus.$off(ANIMATE_HAMBURGER, this.onAnimateHamburger);
    },
};
</script>
